import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { Flex, Text } from '@atlaskit/primitives/compiled';

import { DetailsRow } from '../../../../common/utils/components/details-row';
import { DetailsSection } from '../../../../common/utils/components/details-section';

import { CopyCorrelationIdButton } from './copy-correlation-id-button';

const messages = defineMessages({
	summary: {
		id: 'organization.audit.log.side-panel.tab-panels.related-activities.summary-section.title',
		defaultMessage: 'Summary',
		description: 'Title for the summary section in audit log related activities panel',
	},
	correlationId: {
		id: 'organization.audit.log.side-panel.tab-panels.related-activities.summary-section.correlation-id.label',
		defaultMessage: 'Correlation ID',
		description: 'Title for the correlation ID row in audit log related activities panel',
	},
});

interface TableHeaderProps {
	correlationId: string | null;
}

const correlationIdComponent = (correlationId: string | null) => {
	if (!correlationId) {
		return null;
	}

	return (
		<Flex alignItems="start" gap="space.075">
			<Text color="color.text.subtle" weight="regular" as="p" size="medium">
				{correlationId}
			</Text>
			<CopyCorrelationIdButton correlationId={correlationId} />
		</Flex>
	);
};

export const TableHeader = ({ correlationId }: TableHeaderProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<DetailsSection title={formatMessage(messages.summary)}>
			<DetailsRow
				label={formatMessage(messages.correlationId)}
				value={correlationIdComponent(correlationId)}
			/>
		</DetailsSection>
	);
};
